<template>
  <div popup-download v-if="download">
    <article>
      <a class="btn-x" @click="close"></a>
      <div class="form">
        <ul class="os">
          <li><label class="radio big"><input type="radio" name="os" value="ad" v-model="info.os"><i></i></label></li>
          <li><label class="radio big"><input type="radio" name="os" value="ios" v-model="info.os"><i></i></label></li>
        </ul>
        <p class="phone">
          <input v-model="info.phone" type='number' maxlength="11" placeholder='휴대폰 번호를 " – " 없이 입력하세요'/>
          <a @click="request"></a>
        </p>
        <ul class="clause">
          <li><label class="checkbox"><input type="checkbox" value="a" v-model="info.agree"><i></i><span></span></label></li>
          <li><label class="checkbox"><input type="checkbox" value="b" v-model="info.agree"><i></i><span></span></label></li>
        </ul>
      </div>
    </article>
    <p class="bg" @click="close"></p>
  </div>
</template>

<script>
import oax from '../utils/oax';

export default {
  name: 'popupDownload',
  data() {
    return {
      info: {
        os: 'ad',
        agree: [],
        cAgree: false,
        phone: null,
      },
    };
  },
  computed: {
    download() {
      if (!this.$store.state.downloadOn) return false;
      return this.$store.state.downloadOn;
    },
  },
  methods: {
    close(e) {
      if (e) e.stopPropagation();
      this.$store.commit('offDownload');
    },
    request() {
      let msg = null;
      if (this.info.agree.length < 2) { msg = '정보이용 동의가 필요합니다. <br/> 개인 정보 수집 및 처리 위탁 동의 체크해주세요.'; }
      if (!this.info.phone || this.info.phone.length < 11) { msg = '휴대폰 번호를 정확하게 입력해주세요.'; }
      if (msg) {
        this.$store.commit('onMsg', msg);
        return;
      }

      console.log(this.info);

      oax.post('/api/send/', {
        phone: this.info.phone, store: this.info.os, agree1: 'true', agree2: 'true',
      })
        .then(({ data }) => {
          this.$store.commit('onMsg', data.retMsg);
          if (data.retCode === 100 || data.retCode === 101) {
            // window.fbq('track', 'CompleteRegistration');
            // window.adpick_webtracking({ site: 'gamevil', event: 'registered', match_key: window.md5(this.info.phone) });
            window.gtag('event', 'click', { event_category: 'SMS_Download' });
            this.$store.commit('offDownload');
          }
        });
    },
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{[popup-download]{.hide;}}
  .pc{
    [popup-download]{ .fix; .t(0); z-index: 999; .wh(100%); background:rgba(0,0,0,0.6); overflow: auto;
      article{.abs; .wh(1000px,1300px); z-index:100; .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .contain("@{pc}/popup-download.jpg"); .m(50px,0);
        .btn-x{.block; .wh(90px,90px); .r(0); .t(0); .abs;}
        .form{.wh(100%); .p(453px,93px,0); .-box;
          .os{
            li{.ib;
              &:last-of-type{ .ml(278px);}
            }
          }
          .phone{ .wh(100%,74px); .mt(60px); .clear;
            input{background: #3d1814;  .-a(#af272b); .wh(552px,100%); .tc; color:#ffd2a6; .fs(26px); outline: none;
              &::placeholder{.fs(26px); color:#ffd2a6;}
            }
            a{.wh(250px,78px); .ib; .fr;}
          }
          .clause{.mt(24px);
            li{.ib;
              &:last-of-type{.ml(246px);}
            }
          }
        }
      }
      .bg{.wh(100%);}

      @media screen and (max-height: 1300px){
        article{.t(0); transform: translate(-50%,0);}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupDownload.vue